import React from 'react';
import { Loader2 } from 'lucide-react';

type Variant = 'primary' | 'secondary' | 'ghost' | 'danger';
type Size = 'sm' | 'md';

interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  loading?: boolean;
}

const VARIANTS: Record<Variant, string> = {
  primary: 'text-white bg-gradient-to-r from-pink-500 to-rose-500 hover:from-pink-600 hover:to-rose-600 shadow-sm',
  secondary: 'text-gray-700 bg-white border border-gray-200 hover:border-pink-300 hover:text-pink-600',
  ghost: 'text-gray-600 hover:bg-gray-100',
  danger: 'text-white bg-red-500 hover:bg-red-600 shadow-sm',
};

const SIZES: Record<Size, string> = {
  sm: 'px-3 py-1.5 text-sm gap-1.5',
  md: 'px-5 py-2.5 text-sm gap-2',
};

export default function Button({
  variant = 'primary', size = 'md', loading = false,
  disabled, className = '', children, type, ...rest
}: Props) {
  return (
    <button
      type={type ?? 'button'}
      disabled={disabled || loading}
      className={`inline-flex items-center justify-center font-medium rounded-xl transition focus:outline-none focus:ring-2 focus:ring-pink-400/50 disabled:opacity-50 disabled:cursor-not-allowed ${VARIANTS[variant]} ${SIZES[size]} ${className}`}
      {...rest}
    >
      {loading && <Loader2 className="w-4 h-4 animate-spin" />}
      {children}
    </button>
  );
}
